module.exports = __webpack_public_path__ + "img/link.2672a9e8.svg";